export default __webpack_public_path__ + "56d413484de85668a6e5b487fecb2373.png";